import { hookstate, useHookstate } from '@hookstate/core';
import { localstored } from '@hookstate/localstored';

const store = hookstate({}, localstored({
    key: 'uniq-user-store',
    engine: localStorage
}))

const wrapState = (s) => ({
    get: () => s.value,
    set: (newVal) => s.set(newVal),
    setUser: (body) => s.user.set(body),
    setFirst: (prop, propFirst, value) => s[prop]?.[propFirst]?.set(value),
    getByProp: (prop) => s[prop].value,
    getByPropFirst: (prop, propFirst) => s[prop][propFirst].value,
    mergeRoot: (value) => s.merge(value),
    reset: () => s.user.set({})
})

export const accessGlobalUserState = () => wrapState(store)
export const useGlobalUserState = () => wrapState(useHookstate(store))